import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { BrowserRouter } from 'react-router-dom';

const theme = createTheme({
  typography: {
    fontFamily: "Helvetica, Arial, sans-serif",
  },
});

const baseName = process.env.REACT_APP_BASE_PATH || "/";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter basename={baseName}>
    <App />
  </BrowserRouter>
);

reportWebVitals();
